import { render, staticRenderFns } from "./Diagnost.vue?vue&type=template&id=10467d82&scoped=true&"
import script from "./Diagnost.vue?vue&type=script&lang=js&"
export * from "./Diagnost.vue?vue&type=script&lang=js&"
import style0 from "./Diagnost.vue?vue&type=style&index=0&id=10467d82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10467d82",
  null
  
)

export default component.exports